import { createContext, useContext } from 'react';
export const AuthContext = createContext({
    authService: null,
    authState: null,
});
export const useAuth = () => {
    const values = useContext(AuthContext);
    return values;
};
